module.exports = __webpack_public_path__ + "images/menzis_smallbda5bd5c369dcd5c966a2c2bd11c9b4f.png";